/**
 * @file index.tsx
 *
 * @fileoverview Renders a featured section with icons on a colored background.
 */
import React from 'react';
import dynamic from 'next/dynamic';
import { FeatureGridOnBrandParagraph } from '~/jobiqo/types/types';
import { Box } from '~/vcl/atoms/07-box';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { Text } from '~/vcl/atoms/13-text/03-text';

const LandingPageIcon = dynamic(
  () => import('~/jobiqo/components/Landingpage/LandingPageIcon'),
  {
    ssr: false,
  },
);

interface FeatureGridOnBrandProps {
  row: FeatureGridOnBrandParagraph;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}
export const FeatureGridOnBrand = ({
  row,
  maxContainerSize,
}: FeatureGridOnBrandProps) => {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      marginTop={0}
      paddingTop={row.spacing ?? 11}
      paddingBottom={row.spacing ?? 12}
      backgroundColorOverride={`var(--color-${row.color})`}
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        {row.featuredOnBrandSubtitle && (
          <>
            <Text color="white" fontWeight="bold" textTransform="uppercase">
              {row.featuredOnBrandSubtitle}
            </Text>
            <Spacing size="medium" />
          </>
        )}
        {row.title && (
          <>
            <Text color="white" tag="h2" fontSize={[5, 7]} lineHeight={[5, 7]}>
              {row.title}
            </Text>
            <Spacing size="large" />
          </>
        )}
        {row.text && (
          <Text color="white" fontSize={4} lineHeight={5}>
            {row.text}
          </Text>
        )}
        <Spacing marginBottom={11} />
        <Grid columns={[1, 3]} gap={7}>
          {row.items?.map((item, index) => {
            return (
              item && (
                <Cell key={index}>
                  <div>
                    <FlexItems>
                      {(item.icon || item.iconCustom) && (
                        <FlexItem marginBottom={5}>
                          <Box
                            marginTop={0}
                            paddingTop={6}
                            paddingBottom={5}
                            paddingLeft={6}
                            paddingRight={6}
                            backgroundColorOverride="rgba(0,0,0,0.2)"
                          >
                            <LandingPageIcon
                              icon={item?.icon}
                              iconCustom={item?.iconCustom}
                              color="white"
                              height="20"
                              width="20"
                            />
                          </Box>
                        </FlexItem>
                      )}
                    </FlexItems>
                    <Text
                      color={`${row.color}VeryLight` as any}
                      tag="p"
                      fontSize={4}
                    >
                      {item.title}
                    </Text>
                    <Text color="white">{item.text}</Text>
                    <Spacing size="medium" />
                  </div>
                </Cell>
              )
            );
          })}
        </Grid>
      </Main>
    </Box>
  );
};
export default FeatureGridOnBrand;
